import { CONVERTER_COMMON_LANG } from "./common";
import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const CONVERTER_STUDY_MEMBER_LANG: {
  STUDY_MEMBER_INVITATION_TITLE: MvnCodeFE;
  STUDY_MEMBER_INVITATION_STUDY_NAME_NOUN: MvnCodeFE;
  STUDY_MEMBER_INVITATION_CONTENT_INVITER: MvnCodeFE;
  STUDY_MEMBER_INVITATION_CONTENT_STUDY: MvnCodeFE;
  STUDY_MEMBER_INVITATION_CONTENT_JOIN: MvnCodeFE;
  STUDY_MEMBER_INVITATION_JOIN_NOUN: MvnCodeFE;
  STUDY_MEMBER_STATUS_INVITED: MvnCodeFE;
  STUDY_MEMBER_STATUS_REGISTERED: MvnCodeFE;
  STUDY_MEMBER_STATUS_LEFT: MvnCodeFE;
  MEMBERS_TAB: MvnCodeFE;
  ROLES_TAB: MvnCodeFE;

  MEMBER_NOUN: MvnCodeFE;
  ROLE_NOUN: MvnCodeFE;

  RESEND_VERB: MvnCodeFE;
  DELETE_VERB: MvnCodeFE;

  ADD_ROLE_VERB: MvnCodeFE;
  INVITE_VERB: MvnCodeFE;

  ROLE_DUPLICATE_DESCRIPTION: MvnCodeFE;

  CREATE_MEMBER_ROLE_SUCCEED: MvnCodeFE;
  CREATE_MEMBER_ROLE_FAIL: MvnCodeFE;
  MODIFY_MEMBER_ROLE_NAME_SUCCEED: MvnCodeFE;
  MODIFY_MEMBER_ROLE_NAME_FAIL: MvnCodeFE;
  MODIFY_MEMBER_ROLE_STATUS_SUCCEED: MvnCodeFE;
  MODIFY_MEMBER_ROLE_STATUS_FAIL: MvnCodeFE;
  MODIFY_MEMBER_ROLE_PRIVILEGES_SUCCEED: MvnCodeFE;
  MODIFY_MEMBER_ROLE_PRIVILEGES_FAIL: MvnCodeFE;

  STUDY_MEMBER_INVITATION_SUCCEED: MvnCodeFE;
  STUDY_MEMBER_INVITATION_FAIL: MvnCodeFE;

  STUDY_MEMBER_RESEND_EMAIL_SUCCEED: MvnCodeFE;
  STUDY_MEMBER_RESEND_EMAIL_FAIL: MvnCodeFE;

  DELETION_MEMBER_SUCCEED: MvnCodeFE;
  DELETION_MEMBER_FAIL: MvnCodeFE;
  DELETION_MEMBER_ROLE_SUCCEED: MvnCodeFE;
  DELETION_MEMBER_ROLE_FAIL: MvnCodeFE;

  STUDY_ROLE_SWITCH_CONFIRM_TITLE: MvnCodeFE;
  STUDY_ROLE_SWITCH_CONFIRM_DESCRIPTION: MvnCodeFE;

  STUDY_MEMBER_ROLE_MODIFICATION_TITLE: MvnCodeFE;
  STUDY_MEMBER_ROLE_MODIFICATION_ROLE_INACTIVE_DESCRIPTION: MvnCodeFE;
  STUDY_MEMBER_ROLE_MODIFICATION_ROLE_DELETION_DESCRIPTION: MvnCodeFE;

  STUDY_MEMBER_TABLE_HEADER_NO: MvnCodeFE;
  STUDY_MEMBER_TABLE_HEADER_TYPE: MvnCodeFE;
  STUDY_MEMBER_TABLE_HEADER_NAME: MvnCodeFE;
  STUDY_MEMBER_TABLE_HEADER_EMAIL: MvnCodeFE;
  STUDY_MEMBER_TABLE_HEADER_ROLE: MvnCodeFE;
  STUDY_MEMBER_TABLE_HEADER_STATUS: MvnCodeFE;
  STUDY_MEMBER_TABLE_HEADER_LAST_SENT_EMAIL_DATE: MvnCodeFE;
  STUDY_MEMBER_TABLE_HEADER_ACTIVATED_AT: MvnCodeFE;

  STUDY_MEMBER_INVITATION_DIALOG_TITLE: MvnCodeFE;
  STUDY_MEMBER_INVITATION_DIALOG_EMAIL_PLACEHOLDER: MvnCodeFE;
  STUDY_MEMBER_INVITATION_DIALOG_ROLE_PLACEHOLDER: MvnCodeFE;

  MODIFY_MEMBER_ROLE_SUCCEED: MvnCodeFE;
  MODIFY_MEMBER_ROLE_FAIL: MvnCodeFE;

  STUDY_ROLE_ADD_BUTTON: MvnCodeFE;
  STUDY_ROLE_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_MENU_RENAME: MvnCodeFE;
  STUDY_ROLE_MENU_DELETE: MvnCodeFE;

  STUDY_ROLE_PRIVILEGE_POPOVER_TITLE: MvnCodeFE;

  // General
  STUDY_ROLE_MEMBER_FULL_ACCESS_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_MEMBER_VIEW_ACCESS_DESCRIPTION: MvnCodeFE;
  // SDTM
  STUDY_ROLE_STUDY_LIST_VIEW_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_STUDY_VIEW_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_STUDY_CREATION_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_STUDY_DELETION_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_STUDY_MODIFICATION_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_STUDY_LOCK_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_STUDY_COPY_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_IMPORT_FULL_ACCESS_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_DATASETS_VARIABLES_FULL_ACCESS_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_MY_DICTIONARY_FULL_ACCESS_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_CONVERSION_FACTORS_FULL_ACCESS_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_DEFINE_XML_FULL_ACCESS_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_DATA_FLOW_FULL_ACCESS_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_CRF_LABELING_FULL_ACCESS_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_VALIDATION_FULL_ACCESS_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_AUDIT_TRAIL_FULL_ACCESS_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_IMPORT_VIEW_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_DATASETS_VARIABLES_VIEW_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_MY_DICTIONARY_VIEW_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_CONVERSION_FACTORS_VIEW_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_DEFINE_XML_VIEW_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_DATA_FLOW_VIEW_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_CRF_LABELING_VIEW_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_VALIDATION_VIEW_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_AUDIT_TRAIL_VIEW_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_IMPORT_BROWSER_EXPORT_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_MY_DICTIONARY_EXPORT_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_CONVERSION_FACTORS_EXPORT_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_DEFINE_XML_EXPORT_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_CRF_LABELING_EXPORT_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_AUDIT_TRAIL_EXPORT_DESCRIPTION: MvnCodeFE;
  // ADaM
  STUDY_ROLE_SOURCE_DATA_FULL_ACCESS_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_DATASETS_VARIABLES_FULL_ACCESS_ADAM_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_MY_DICTIONARY_FULL_ACCESS_ADAM_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_DATA_FLOW_FULL_ACCESS_ADAM_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_DEFINE_XML_FULL_ACCESS_ADAM_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_VALIDATION_FULL_ACCESS_ADAM_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_AUDIT_TRAIL_FULL_ACCESS_ADAM_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_SOURCE_DATA_VIEW_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_DATASETS_VARIABLES_VIEW_ADAM_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_MY_DICTIONARY_VIEW_ADAM_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_DATA_FLOW_VIEW_ADAM_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_DEFINE_XML_VIEW_ADAM_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_VALIDATION_VIEW_ADAM_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_AUDIT_TRAIL_VIEW_ADAM_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_SOURCE_DATA_EXPORT_PARTIAL_ACCESS_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_DATASETS_VARIABLES_PARTIAL_ACCESS_ADAM_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_MY_DICTIONARY_EXPORT_PARTIAL_ACCESS_ADAM_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_DEFINE_XML_EXPORT_PARTIAL_ACCESS_ADAM_DESCRIPTION: MvnCodeFE;
  STUDY_ROLE_AUDIT_TRAIL_EXPORT_ACCESS_ADAM_DESCRIPTION: MvnCodeFE;
} = {
  STUDY_MEMBER_INVITATION_TITLE: {
    ko: "[Maven Converter]에 초대되었습니다.",
    en: "You’ve been invited to [Maven Converter].",
  },
  STUDY_MEMBER_INVITATION_STUDY_NAME_NOUN: {
    ko: "스터디 이름",
    en: "Study Name",
  },
  STUDY_MEMBER_INVITATION_CONTENT_INVITER: {
    ko: "{inviter} ({inviterEmail}) 께서",
    en: "{inviter} ({inviterEmail}) has",
  },
  STUDY_MEMBER_INVITATION_CONTENT_STUDY: {
    ko: "귀하를 Maven Converter의 {studyName} 에 초대했습니다.",
    en: "invited you to join the {studyName} in Maven Converter.",
  },

  STUDY_MEMBER_INVITATION_CONTENT_JOIN: {
    ko: "Join 버튼을 클릭하여 초대받은 스터디를 확인할 수 있습니다.",
    en: "Press the 'Join' button to access the study.",
  },
  STUDY_MEMBER_INVITATION_JOIN_NOUN: {
    ko: "Join",
    en: "Join",
  },
  STUDY_MEMBER_STATUS_INVITED: {
    ko: "초대됨",
    en: "Invited",
  },
  STUDY_MEMBER_STATUS_REGISTERED: {
    ko: "등록됨",
    en: "Registered",
  },
  STUDY_MEMBER_STATUS_LEFT: {
    ko: "ORG에서 삭제됨",
    en: "Deleted from the ORG",
  },
  MEMBERS_TAB: {
    ko: "Members",
    en: "Members",
  },
  ROLES_TAB: {
    ko: "Roles",
    en: "Roles",
  },

  MEMBER_NOUN: {
    ko: "Member",
    en: "Member",
  },
  ROLE_NOUN: {
    ko: "Role",
    en: "Role",
  },

  RESEND_VERB: {
    ko: "재발송",
    en: "Send a Email",
  },
  DELETE_VERB: {
    ko: "삭제",
    en: "Remove",
  },

  ADD_ROLE_VERB: {
    ko: "역할 추가",
    en: "Add Role",
  },
  INVITE_VERB: {
    ko: "초대",
    en: "Invite",
  },

  ROLE_DUPLICATE_DESCRIPTION: {
    ko: "동일한 이름의 역할이 존재합니다.",
    en: "Duplicate role name detected.",
  },

  CREATE_MEMBER_ROLE_SUCCEED: {
    ko: "역할 생성을 완료하였습니다.",
    en: "Role creation completed.",
  },
  CREATE_MEMBER_ROLE_FAIL: {
    ko: "역할 생성에 실패하였습니다.",
    en: "Role creation failed.",
  },
  MODIFY_MEMBER_ROLE_NAME_SUCCEED: {
    ko: "역할 이름을 변경했습니다.",
    en: "Role name has been changed.",
  },
  MODIFY_MEMBER_ROLE_NAME_FAIL: {
    ko: "역할 이름 변경에 실패했습니다.",
    en: "Failed to change role name.",
  },
  MODIFY_MEMBER_ROLE_STATUS_SUCCEED: {
    ko: "역할 상태를 변경했습니다.",
    en: "Role status has been updated.",
  },
  MODIFY_MEMBER_ROLE_STATUS_FAIL: {
    ko: "역할 상태 변경에 실패했습니다.",
    en: "Failed to update role status.",
  },
  MODIFY_MEMBER_ROLE_PRIVILEGES_SUCCEED: {
    ko: "권한 설정을 저장했습니다.",
    en: "Privilege settings have been saved.",
  },
  MODIFY_MEMBER_ROLE_PRIVILEGES_FAIL: {
    ko: "권한 설정 저장에 실패했습니다.",
    en: "Failed to save privilege settings.",
  },
  STUDY_MEMBER_INVITATION_SUCCEED: {
    ko: "멤버 초대를 완료했습니다.",
    en: "The member invitation has been completed.",
  },
  STUDY_MEMBER_INVITATION_FAIL: {
    ko: "멤버 초대에 실패했습니다.",
    en: "Failed to invite members.",
  },
  STUDY_MEMBER_RESEND_EMAIL_SUCCEED: {
    ko: "초대 메일이 재발송 되었습니다.",
    en: "The invitation email has been resent.",
  },
  STUDY_MEMBER_RESEND_EMAIL_FAIL: {
    ko: "초대 메일 재발송에 실패했습니다.",
    en: "Failed to resend the invitation email.",
  },

  DELETION_MEMBER_SUCCEED: {
    ko: "맴버 삭제를 완료했습니다.",
    en: "The member has been deletion.",
  },
  DELETION_MEMBER_FAIL: {
    ko: "맴버 삭제에 실패했습니다.",
    en: "Failed to deletion the member.",
  },
  DELETION_MEMBER_ROLE_SUCCEED: {
    ko: "역할을 삭제 했습니다.",
    en: "The role has been deleted.",
  },
  DELETION_MEMBER_ROLE_FAIL: {
    ko: "역할 삭제에 실패했습니다.",
    en: "Failed to delete role.",
  },

  STUDY_ROLE_SWITCH_CONFIRM_TITLE: {
    ko: "탭 이동 확인",
    en: "Switch Tab Confirmation",
  },
  STUDY_ROLE_SWITCH_CONFIRM_DESCRIPTION: {
    ko: "현재 편집 중인 내용이 저장되지 않았습니다.\n탭 이동시 편집 내용은 복구되지 않습니다.\n\n다른 탭으로 이동하시겠습니까?",
    en: "The contents of the current editing are not stored.\nIf you move without storing it, the data in editing will be lost.\n\nWould you like to go to another tab?",
  },

  STUDY_MEMBER_ROLE_MODIFICATION_TITLE: {
    ko: "역할 변경",
    en: "Change Role",
  },
  STUDY_MEMBER_ROLE_MODIFICATION_ROLE_DELETION_DESCRIPTION: {
    ko: "삭제할 역할을 사용중인 멤버가 존재합니다.\n해당 멤버의 역할을 변경하여, 역할 삭제 작업을 계속 진행할 수 있습니다.",
    en: "There is a member currently using this role.\nYou can change the member’s role and then proceed to delete this role.",
  },
  STUDY_MEMBER_ROLE_MODIFICATION_ROLE_INACTIVE_DESCRIPTION: {
    ko: "역할을 사용중인 멤버가 존재합니다.\n해당 멤버의 역할을 변경하여, 역할 비활성화 작업을 계속 진행할 수 있습니다.",
    en: "A member is currently assigned to this role.\nPlease change the member’s role before disabling it.",
  },

  STUDY_MEMBER_TABLE_HEADER_NO: {
    ko: "No.",
    en: "No.",
  },
  STUDY_MEMBER_TABLE_HEADER_TYPE: {
    ko: "유형",
    en: "Type",
  },
  STUDY_MEMBER_TABLE_HEADER_NAME: {
    ko: "이름",
    en: "Name",
  },
  STUDY_MEMBER_TABLE_HEADER_EMAIL: {
    ko: "Email",
    en: "Email",
  },
  STUDY_MEMBER_TABLE_HEADER_ROLE: {
    ko: "역할",
    en: "Role",
  },
  STUDY_MEMBER_TABLE_HEADER_STATUS: {
    ko: "상태",
    en: "Status",
  },
  STUDY_MEMBER_TABLE_HEADER_LAST_SENT_EMAIL_DATE: {
    ko: "최근 메일 발송일",
    en: "Last Sent Email Date",
  },
  STUDY_MEMBER_TABLE_HEADER_ACTIVATED_AT: {
    ko: "시작 일시",
    en: "Activated At",
  },
  STUDY_MEMBER_INVITATION_DIALOG_TITLE: {
    ko: "멤버 초대",
    en: "Invite Member",
  },
  STUDY_MEMBER_INVITATION_DIALOG_EMAIL_PLACEHOLDER: {
    ko: "초대할 멤버 선택  또는 직접 입력",
    en: "Select or directly input members to invite",
  },
  STUDY_MEMBER_INVITATION_DIALOG_ROLE_PLACEHOLDER: {
    ko: "역할 선택",
    en: "Select a role.",
  },
  MODIFY_MEMBER_ROLE_SUCCEED: {
    ko: "역할 변경을 완료했습니다.",
    en: "The role change has been completed.",
  },
  MODIFY_MEMBER_ROLE_FAIL: {
    ko: "역할 변경에 실패했습니다.",
    en: "Failed to change the role.",
  },

  STUDY_ROLE_ADD_BUTTON: {
    ko: "역할 추가",
    en: "Add Role",
  },
  STUDY_ROLE_MENU_RENAME: {
    ko: "이름 변경",
    en: "Rename",
  },
  STUDY_ROLE_MENU_DELETE: CONVERTER_COMMON_LANG.DELETE_VERB,
  STUDY_ROLE_DESCRIPTION: {
    ko: "Role을 활성화 하면, Members에서 사용자에게 부여할 수 있는 Role목록의 값으로 추가 됩니다.",
    en: "Once a role is activated, it becomes available for assignment to users in Members.",
  },
  STUDY_ROLE_PRIVILEGE_POPOVER_TITLE: {
    ko: "Privileges별 권한 기능 정보",
    en: "Permission Details by Privilege",
  },

  // General
  STUDY_ROLE_MEMBER_FULL_ACCESS_DESCRIPTION: {
    ko: "Role과 멤버 관리의 모든 기능을 사용할 수 있다.",
    en: "Permission to use all Role and Members Management functions.",
  },
  STUDY_ROLE_MEMBER_VIEW_ACCESS_DESCRIPTION: {
    ko: "Role과 멤버의 목록을 볼 수 있다.",
    en: "Privilege to see a list of role and members in Study.",
  },

  // SDTM
  STUDY_ROLE_STUDY_LIST_VIEW_DESCRIPTION: {
    ko: "Study 에서 스터디 목록을 볼 수 있다.",
    en: "Privilege to see a list of studies in Study.",
  },
  STUDY_ROLE_STUDY_VIEW_DESCRIPTION: {
    ko: "Study를 클릭하여 상세 화면에 진입할 수 있다.",
    en: "Privilege to view and enter the Study workspace.",
  },
  STUDY_ROLE_STUDY_MODIFICATION_DESCRIPTION: {
    ko: "Study 정보 수정 권한",
    en: "Privilege to modify study information.",
  },
  STUDY_ROLE_STUDY_CREATION_DESCRIPTION: {
    ko: "Study 생성 권한",
    en: "Privilege to create study.",
  },
  STUDY_ROLE_STUDY_COPY_DESCRIPTION: {
    ko: "Study 복사 권한",
    en: "Privilege to copy study.",
  },
  STUDY_ROLE_STUDY_DELETION_DESCRIPTION: {
    ko: "Study 삭제 권한",
    en: "Privilege to delete Study workspace.",
  },
  STUDY_ROLE_STUDY_LOCK_DESCRIPTION: {
    ko: "Study 잠금/잠금해제 권한",
    en: "Privilege to lock Study workspace.",
  },
  STUDY_ROLE_IMPORT_FULL_ACCESS_DESCRIPTION: {
    ko: "Import 페이지의 모든 기능을 사용할 수 있다.",
    en: "Privilege to use all features of the Import.",
  },
  STUDY_ROLE_DATASETS_VARIABLES_FULL_ACCESS_DESCRIPTION: {
    ko: "Datasets & Variables의 모든 기능을 사용할 수 있다.",
    en: "Privilege to use all features of the Datasets & Variables.",
  },
  STUDY_ROLE_MY_DICTIONARY_FULL_ACCESS_DESCRIPTION: {
    ko: "My Dictionary의 모든 기능을 사용할 수 있다.",
    en: "Privilege to use all features of the My Dictionary.",
  },
  STUDY_ROLE_CONVERSION_FACTORS_FULL_ACCESS_DESCRIPTION: {
    ko: "Conversion Factors의 모든 기능을 사용할 수 있다.",
    en: "Privilege to use all features of the Conversion Factors.",
  },
  STUDY_ROLE_DEFINE_XML_FULL_ACCESS_DESCRIPTION: {
    ko: "Define-XML 의 모든 기능을 사용할 수 있다.",
    en: "Privilege to use all features of the Define-XML.",
  },
  STUDY_ROLE_DATA_FLOW_FULL_ACCESS_DESCRIPTION: {
    ko: "Data Flow의 모든 기능을 사용할 수 있다.",
    en: "Privilege to use all features of the Data Flow.",
  },
  STUDY_ROLE_CRF_LABELING_FULL_ACCESS_DESCRIPTION: {
    ko: "CRF Labeling 의 모든 기능을 사용할 수 있다.",
    en: "Privilege to use all features of the CRF Labeling.",
  },
  STUDY_ROLE_VALIDATION_FULL_ACCESS_DESCRIPTION: {
    ko: "Validation 의 모든 기능을 사용할 수 있다.",
    en: "Privilege to use all features of the Validation.",
  },
  STUDY_ROLE_AUDIT_TRAIL_FULL_ACCESS_DESCRIPTION: {
    ko: "Audit Trail의 모든 기능을 사용할 수 있다.",
    en: "Privilege to use all features of the Audit Trail.",
  },
  STUDY_ROLE_IMPORT_VIEW_DESCRIPTION: {
    ko: "Import 페이지의 파일 목록과 파일 열람기 또는 파일 브라우저의 목록을 볼 수 있다.",
    en: "Privilege to view data file lists in the Import or Browser.",
  },
  STUDY_ROLE_DATASETS_VARIABLES_VIEW_DESCRIPTION: {
    ko: "Datasets & Variables의 후보 데이터 셋/타겟 데이터셋 및 대상 변수 목록을 볼 수 있다.",
    en: "Privilege to see candidate and target datasets, and the list of target variables.",
  },
  STUDY_ROLE_MY_DICTIONARY_VIEW_DESCRIPTION: {
    ko: "SDTM CT 및 My Dictionary목록을 보고, 검색 기능을 사용할 수 있다.",
    en: "Privilege to see the SDTM CT and My Dictionary lists, and to use the search function.",
  },
  STUDY_ROLE_CONVERSION_FACTORS_VIEW_DESCRIPTION: {
    ko: "설정된 Conversion Factors 목록을 보고, 검색 기능을 사용할 수 있다.",
    en: "Privilege to see the list of configured conversion factors and use the search function.",
  },
  STUDY_ROLE_DEFINE_XML_VIEW_DESCRIPTION: {
    ko: "Define-XML 의 설정된 내용을 볼 수 있고, 검색 기능을 사용할 수 있다.",
    en: "Privilege to see the configured contents of Define-XML and to use the search function.",
  },
  STUDY_ROLE_DATA_FLOW_VIEW_DESCRIPTION: {
    ko: "Data Flow의 Flow list 선택시 작업보드의 노드를 볼 수 있고, 각 노드 클릭시 데이터셋별로 데이터 세트를 볼 수 있다.",
    en: "Privilege to see nodes on the workboard when selecting a flow from the Data Flow list, and to view datasets by clicking each node.",
  },
  STUDY_ROLE_CRF_LABELING_VIEW_DESCRIPTION: {
    ko: "CRF Labeling 의 데이터 세트 및 변수 목록과 데이터 세트별 선정된 컬러 및 CRF 편집 창에서 라벨링 된 상태를 볼 수 있다.",
    en: "Privilege to see the dataset and variable list labeled for CRF, highlighted by permission level, and visible only within the CRF editing window for each dataset.",
  },
  STUDY_ROLE_VALIDATION_VIEW_DESCRIPTION: {
    ko: "Validation 검사 대상 데이터 셋 목록과 검증 설정 목록을 볼 수 있다.",
    en: "Privilege to see a list of source datasets and validation configuration on Validation.",
  },
  STUDY_ROLE_AUDIT_TRAIL_VIEW_DESCRIPTION: {
    ko: "Audit Trail의 검색 기능을 사용하여 로그를 볼 수 있다.",
    en: "Privilege to use the search function to view logs on the Audit Trail.",
  },
  STUDY_ROLE_IMPORT_BROWSER_EXPORT_DESCRIPTION: {
    ko: "Import의 Export 기능을 사용할 수 있다.",
    en: "Privilege to use the Export function of Import.",
  },
  STUDY_ROLE_MY_DICTIONARY_EXPORT_DESCRIPTION: {
    ko: "My Dictionary의 Export 기능을 사용할 수 있다.",
    en: "Privilege to use the Export function of My Dictionary.",
  },
  STUDY_ROLE_CONVERSION_FACTORS_EXPORT_DESCRIPTION: {
    ko: "Conversion Factors의 Export 기능을 사용할 수 있다.",
    en: "Privilege to use the Export function of Conversion Factors.",
  },
  STUDY_ROLE_DEFINE_XML_EXPORT_DESCRIPTION: {
    ko: "Define-XML의 Export 기능을 사용할 수 있다.",
    en: "Privilege to use the Export function of Define-XML.",
  },
  STUDY_ROLE_CRF_LABELING_EXPORT_DESCRIPTION: {
    ko: "CRF Labeling의 Export 기능을 사용할 수 있다.",
    en: "Privilege to use the Export function of CRF Labeling.",
  },
  STUDY_ROLE_AUDIT_TRAIL_EXPORT_DESCRIPTION: {
    ko: "Audit Trail의 Export 기능을 사용할 수 있다.(Audit Trail_View와 함께 부여되어야 한다.)",
    en: "Privilege to use the Audit Trail Export function(Requires Audit Trail_View).",
  },

  // ADaM
  STUDY_ROLE_SOURCE_DATA_FULL_ACCESS_DESCRIPTION: {
    ko: "Source Data 페이지의 모든 기능을 사용할 수 있다.",
    en: "Privilege to use all features of the Source Data.",
  },
  STUDY_ROLE_DATASETS_VARIABLES_FULL_ACCESS_ADAM_DESCRIPTION: {
    ko: "Datasets & Variables의 모든 기능을 사용할 수 있다.",
    en: "Privilege to use all features of the Datasets & Variables.",
  },
  STUDY_ROLE_MY_DICTIONARY_FULL_ACCESS_ADAM_DESCRIPTION: {
    ko: "My Dictionary의 모든 기능을 사용할 수 있다.",
    en: "Privilege to use all features of the My Dictionary.",
  },
  STUDY_ROLE_DATA_FLOW_FULL_ACCESS_ADAM_DESCRIPTION: {
    ko: "Data Flow의 모든 기능을 사용할 수 있다.",
    en: "Privilege to use all features of the Data Flow.",
  },
  STUDY_ROLE_DEFINE_XML_FULL_ACCESS_ADAM_DESCRIPTION: {
    ko: "Define-XML 의 모든 기능을 사용할 수 있다.",
    en: "Privilege to use all features of the Define-XML.",
  },
  STUDY_ROLE_VALIDATION_FULL_ACCESS_ADAM_DESCRIPTION: {
    ko: "Validation 의 모든 기능을 사용할 수 있다.",
    en: "Privilege to use all features of the Validation.",
  },
  STUDY_ROLE_AUDIT_TRAIL_FULL_ACCESS_ADAM_DESCRIPTION: {
    ko: "Audit Trail의 모든 기능을 사용할 수 있다.",
    en: "Privilege to use all features of the Audit Trail.",
  },
  STUDY_ROLE_SOURCE_DATA_VIEW_DESCRIPTION: {
    ko: "Source Data 페이지의 파일 목록을 볼 수 있다.",
    en: "Privilege to view data file lists.",
  },
  STUDY_ROLE_DATASETS_VARIABLES_VIEW_ADAM_DESCRIPTION: {
    ko: "Datasets & Variables의 후보 데이터 스트럭처와 타겟 데이터셋 및 대상 변수 목록을 볼 수 있다.",
    en: "Privilege to view candidate data structures and variables, as well as target datasets and variables.",
  },
  STUDY_ROLE_MY_DICTIONARY_VIEW_ADAM_DESCRIPTION: {
    ko: "ADaM CT 및 My Dictionary목록을 보고, 검색 기능을 사용할 수 있다.",
    en: "Privilege to see the ADaM CT and My Dictionary lists, and to use the search function.",
  },
  STUDY_ROLE_DATA_FLOW_VIEW_ADAM_DESCRIPTION: {
    ko: "Data Flow의 Flow list 선택시 작업보드의 노드를 볼 수 있고, 각 노드 클릭시 데이터셋별로 데이터 세트를 볼 수 있다.",
    en: "Privilege to see nodes on the workboard when selecting a flow from the Data Flow list, and to view datasets by clicking each node.",
  },
  STUDY_ROLE_DEFINE_XML_VIEW_ADAM_DESCRIPTION: {
    ko: "Define-XML 의 설정된 내용을 볼 수 있고, 검색 기능을 사용할 수 있다.",
    en: "Privilege to see the configured contents of Define-XML and to use the search function.",
  },
  STUDY_ROLE_VALIDATION_VIEW_ADAM_DESCRIPTION: {
    ko: "Validation 검사 대상 데이터 셋 목록과 검증 설정 목록을 볼 수 있다.",
    en: "Privilege to see a list of source datasets and validation configuration on Validation.",
  },
  STUDY_ROLE_AUDIT_TRAIL_VIEW_ADAM_DESCRIPTION: {
    ko: "Audit Trail의 검색 기능을 사용하여 로그를 볼 수 있다.",
    en: "Privilege to use the search function of the Audit Trail.",
  },
  STUDY_ROLE_SOURCE_DATA_EXPORT_PARTIAL_ACCESS_DESCRIPTION: {
    ko: "Source Data의 Export 기능을 사용할 수 있다.",
    en: "Privilege to use the Export function of Source Data.",
  },
  STUDY_ROLE_DATASETS_VARIABLES_PARTIAL_ACCESS_ADAM_DESCRIPTION: {
    ko: "Datasets & Variables의 Export 기능을 사용할 수 있다.",
    en: "Privilege to use the Export function of Datasets & Variables.",
  },
  STUDY_ROLE_MY_DICTIONARY_EXPORT_PARTIAL_ACCESS_ADAM_DESCRIPTION: {
    ko: "My Dictionary의 Export 기능을 사용할 수 있다.",
    en: "Privilege to use the Export function of My Dictionary.",
  },
  STUDY_ROLE_DEFINE_XML_EXPORT_PARTIAL_ACCESS_ADAM_DESCRIPTION: {
    ko: "Define-XML의 [내보내기] 버튼을 사용할 수 있다.",
    en: "Privilege to use the [Export] button of Define-XML.",
  },
  STUDY_ROLE_AUDIT_TRAIL_EXPORT_ACCESS_ADAM_DESCRIPTION: {
    ko: "Audit Trail의 Export 기능을 사용할 수 있다(Audit Trail_View와 함께 부여되어야 한다).",
    en: "Privilege to use the Audit Trail Export function (requires Audit Trail_View).",
  },
};
//
MvnCodeInitiate(CONVERTER_STUDY_MEMBER_LANG);
